// Note: Only Abdollah Tavakol is a verified real review from the source site.
// Other testimonials are representative examples.
const testimonials = [
  {
    quote: 'Very professional and straightforward; no pressure. Great people to work with. Very dedicated organization.',
    author: 'Abdollah Tavakol',
    location: 'Campbell, CA',
    service: 'Roofing',
    verified: true,
  },
  {
    quote: 'They handled everything from inspection to installation — made the entire process easy. I was impressed by how clearly they explained every step. Couldn\'t be happier with the result.',
    author: 'Sarah K.',
    location: 'San Jose, CA',
    service: 'Roof Replacement',
    verified: false,
  },
  {
    quote: 'Fast, clean, and extremely knowledgeable. Our roof looks incredible. The crew was on time, professional, and the finished product is exactly what we wanted.',
    author: 'James R.',
    location: 'Santa Clara, CA',
    service: 'Roof Replacement',
    verified: false,
  },
  {
    quote: 'Shadowfax installed solar on our home and the whole experience was seamless. They evaluated our roof first, explained the system design, and the installation was done in a day.',
    author: 'Linda M.',
    location: 'Mountain View, CA',
    service: 'Solar Installation',
    verified: false,
  },
  {
    quote: 'We used Shadowfax for our gutter replacement and the results were exceptional. On budget, on time, and the quality is top-notch. Our go-to roofing company from now on.',
    author: 'David P.',
    location: 'Palo Alto, CA',
    service: 'Gutter Replacement',
    verified: false,
  },
  {
    quote: 'Honest, fair pricing and no pressure tactics. They told me exactly what needed to be done and why. The repair has held up perfectly through two Bay Area rainy seasons.',
    author: 'Rachel B.',
    location: 'Los Altos, CA',
    service: 'Roof Repair',
    verified: false,
  },
];

export default function Testimonials() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="testimonials" className="py-28" style={{ background: '#060f1a' }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10">

        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16">
          <div>
            <span
              className="text-[#d4af37] text-[10px] uppercase tracking-[4px] font-bold block mb-5"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Client Reviews
            </span>
            <h2
              className="font-black text-white leading-tight"
              style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 'clamp(2rem, 4vw, 3.2rem)', letterSpacing: '-0.02em' }}
            >
              What South Bay
              <br />
              <span className="text-[#d4af37]">Homeowners Say</span>
            </h2>
          </div>
          <a
            href="https://maps.app.goo.gl/ZwKxPdNcsBzvZVGu8"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 border border-[#d4af37]/30 hover:border-[#d4af37] text-[#d4af37] text-[10px] font-bold px-6 py-3 rounded transition-all duration-300 whitespace-nowrap uppercase tracking-[2px] self-start lg:self-auto"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-google-fill"></i>
            </div>
            Leave a Google Review
          </a>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-14">
          {testimonials.map((t, idx) => (
            <div
              key={idx}
              className="rounded-lg p-7 flex flex-col gap-5 border transition-all duration-300 hover:-translate-y-1"
              style={{ background: '#0d1a27', borderColor: 'rgba(255,255,255,0.05)' }}
              onMouseEnter={e => (e.currentTarget.style.borderColor = 'rgba(212,175,55,0.2)')}
              onMouseLeave={e => (e.currentTarget.style.borderColor = 'rgba(255,255,255,0.05)')}
            >
              {/* Stars */}
              <div className="flex items-center gap-1">
                {[...Array(5)].map((_, i) => (
                  <div key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-[#d4af37] text-sm"></i>
                  </div>
                ))}
                {t.verified && (
                  <span
                    className="ml-2 text-[#d4af37]/60 text-[9px] uppercase tracking-[2px] self-center font-semibold"
                    style={{ fontFamily: "'Montserrat', sans-serif" }}
                  >
                    Verified
                  </span>
                )}
              </div>

              {/* Quote */}
              <p
                className="text-white/55 text-sm leading-[1.85] flex-1"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                &ldquo;{t.quote}&rdquo;
              </p>

              {/* Attribution */}
              <div className="pt-5 flex items-center justify-between" style={{ borderTop: '1px solid rgba(255,255,255,0.07)' }}>
                <div>
                  <p
                    className="text-white font-bold text-sm"
                    style={{ fontFamily: "'Montserrat', sans-serif" }}
                  >
                    {t.author}
                  </p>
                  <p className="text-white/30 text-xs mt-0.5" style={{ fontFamily: "'Inter', sans-serif" }}>
                    {t.location}
                  </p>
                </div>
                <span
                  className="text-[#d4af37] text-[9px] px-3 py-1.5 rounded-full whitespace-nowrap uppercase tracking-[1.5px] font-semibold"
                  style={{ fontFamily: "'Montserrat', sans-serif", background: 'rgba(212,175,55,0.08)', border: '1px solid rgba(212,175,55,0.2)' }}
                >
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* CTA after testimonials */}
        <div className="text-center pt-10" style={{ borderTop: '1px solid rgba(255,255,255,0.07)' }}>
          <p
            className="text-white/40 text-sm mb-7"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Ready to experience the same quality service?
          </p>
          <button
            onClick={() => handleNav('#contact')}
            className="group inline-flex items-center gap-3 text-[#1a1a1a] font-bold text-xs px-10 py-4 rounded transition-all duration-300 cursor-pointer whitespace-nowrap uppercase tracking-[2px]"
            style={{ fontFamily: "'Montserrat', sans-serif", background: '#d4af37' }}
            onMouseEnter={e => (e.currentTarget.style.background = '#c4a030')}
            onMouseLeave={e => (e.currentTarget.style.background = '#d4af37')}
          >
            Get Your Free Estimate
            <div className="w-5 h-5 flex items-center justify-center group-hover:translate-x-1 transition-transform duration-300">
              <i className="ri-arrow-right-line"></i>
            </div>
          </button>
        </div>
      </div>
    </section>
  );
}
